const onEnterPressed = (event, callback) => {
  const keyCode = event.keyCode || event.which;
  if (event.key === 'Enter' || keyCode === '13') {
    event.preventDefault();
    callback.call();
  }
};

const onClickAndKeypress = ($element, callback, { offClick = false, hasEvent = false } = {}) => {
  const getCallbackFunc = e => {
    return hasEvent ? callback.bind(null, e) : callback;
  };
  if (offClick) {
    $element.off('click').click(function(e) {
      getCallbackFunc(e).call();
    });
    $element.off('keypress').keypress(function(e) {
      e.preventDefault();
      onEnterPressed(e, getCallbackFunc(e));
    });
  } else {
    $element.click(function(e) {
      getCallbackFunc(e).call();
    });

    $element.keypress(function(e) {
      e.preventDefault();
      onEnterPressed(e, getCallbackFunc(e));
    });
  }
};

const Accessibility = {
  onEnterPressed,
  onClickAndKeypress,
};

module.exports = Accessibility;
